import { render } from "./appConfiguration.vue?vue&type=template&id=0083d8d2&scoped=true"
import script from "./appConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./appConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./appConfiguration.vue?vue&type=style&index=0&id=0083d8d2&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0083d8d2"],['__file',"src/views/applications/appConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0083d8d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0083d8d2', __exports__)) {
    console.log('reload')
    api.reload('0083d8d2', __exports__)
  }
  
  module.hot.accept("./appConfiguration.vue?vue&type=template&id=0083d8d2&scoped=true", () => {
    console.log('re-render')
    api.rerender('0083d8d2', render)
  })

}


export default __exports__